import "./module/fade-in.js";
import "./module/accordion.js";

//page表示時フェードイン
document.addEventListener("DOMContentLoaded", function() {
  document.body.style.opacity = 1;
});
//headerスクロールしたら背景色を付与
window.addEventListener("scroll", function() {
  const header = document.querySelector("header");
  if (window.scrollY > 10) {
      header.classList.add("scrolled");
  } else {
      header.classList.remove("scrolled");
  }
});
//マウスカーソル設定
let cursorR = 4;  //カーソルの半径
const cursor = document.getElementById('cursor');  //カーソル用のdivを取得
//上記のdivタグをマウスに追従させる処理
document.addEventListener('mousemove', function (e) {
    cursor.style.transform = 'translate(' + e.clientX + 'px, ' + e.clientY + 'px)';
});
//リンクにホバー時はクラスをつける
const linkElem = document.querySelectorAll('a');
for (let i = 0; i < linkElem.length; i++) {
    linkElem[i].addEventListener('mouseover', function (e) {
        cursor.classList.add('hov_');
    });
    linkElem[i].addEventListener('mouseout', function (e) {
        cursor.classList.remove('hov_');
    });
}
// 全ての入力要素を取得
const inputElem = document.querySelectorAll('input');
// 各入力要素に対してイベントリスナーを追加
inputElem.forEach(inputElem => {
	inputElem.addEventListener('mouseover', function () {
        cursor.classList.add('hov_');
    });
    inputElem.addEventListener('mouseout', function () {
        cursor.classList.remove('hov_');
    });
});
const selectElem = document.querySelectorAll('select');
// 各入力要素に対してイベントリスナーを追加
selectElem.forEach(selectElem => {
	selectElem.addEventListener('mouseover', function () {
        cursor.classList.add('hov_');
    });
    selectElem.addEventListener('mouseout', function () {
        cursor.classList.remove('hov_');
    });
});
const textElem = document.querySelectorAll('textarea');
// 各入力要素に対してイベントリスナーを追加
textElem.forEach(textElem => {
	textElem.addEventListener('mouseover', function () {
        cursor.classList.add('hov_');
    });
    textElem.addEventListener('mouseout', function () {
        cursor.classList.remove('hov_');
    });
});
const iframeElem = document.querySelectorAll('iframe');
// 各入力要素に対してイベントリスナーを追加
iframeElem.forEach(iframeElem => {
	iframeElem.addEventListener('mouseover', function () {
        cursor.classList.add('hov_');
    });
    iframeElem.addEventListener('mouseout', function () {
        cursor.classList.remove('hov_');
    });
});
const buttonElem = document.querySelectorAll('button');
// 各入力要素に対してイベントリスナーを追加
buttonElem.forEach(buttonElem => {
	buttonElem.addEventListener('mouseover', function () {
        cursor.classList.add('hov_');
    });
    buttonElem.addEventListener('mouseout', function () {
        cursor.classList.remove('hov_');
    });
});
const labelElem = document.querySelectorAll('.wpcf7-list-item-label');
labelElem.forEach(labelElem => {
	labelElem.addEventListener('mouseover', function () {
        cursor.classList.add('hov_');
    });
    labelElem.addEventListener('mouseout', function () {
        cursor.classList.remove('hov_');
    });
});
const target = document.querySelector('.l-footer-gotop');
// マウスが要素に乗ったときのイベントリスナー
target.addEventListener('mouseenter', () => {
  cursor.classList.add('hov_');
});
// マウスが要素から離れたときのイベントリスナー
target.addEventListener('mouseleave', () => {
  cursor.classList.remove('hov_');
});
const accordion = document.querySelectorAll('.accordion-box');
// 各入力要素に対してイベントリスナーを追加
accordion.forEach(accordion => {
	accordion.addEventListener('mouseover', function () {
        cursor.classList.add('hov_');
    });
    accordion.addEventListener('mouseout', function () {
        cursor.classList.remove('hov_');
    });
});
const delete_btn = document.querySelectorAll('.mwform-file-delete');
// 各入力要素に対してイベントリスナーを追加
delete_btn.forEach(delete_btn => {
	delete_btn.addEventListener('mouseover', function () {
        cursor.classList.add('hov_');
    });
    delete_btn.addEventListener('mouseout', function () {
        cursor.classList.remove('hov_');
    });
});
//ページトップ
$(function () {
  var scrollTopButton = document.querySelector(".js_page_top");
  scrollTopButton.addEventListener("click", function () {
    window.scroll({
      top: 0,
      behavior: "smooth"
    });
  });
});

//スマホMENU
const menuButton = document.getElementById("menu-button");
const menuLabel = document.getElementById("menu-label");
const menu = document.getElementById("menu");
const body = document.body;
const overlay = document.getElementById("overlay");

function toggleMenu() {
  if (!body.classList.contains("menu-open")) {
    body.classList.add("menu-open");
    menuButton.setAttribute("aria-expanded", "true");
    menuButton.setAttribute("aria-label", "閉じる");
    menu.inert = false;
    if (menuLabel) {
      menuLabel.textContent = "CLOSE";
    }
  } else {
    body.classList.remove("menu-open");
    menuButton.setAttribute("aria-expanded", "false");
    menuButton.setAttribute("aria-label", "メニュー");
    menu.inert = true;
    if (menuLabel) {
      menuLabel.textContent = "MENU";
    }
  }
}
if (menuButton) {
  menuButton.addEventListener("click", toggleMenu);
}
if (overlay) {
  overlay.addEventListener("click", toggleMenu);
}
$(".menu-button").on("click", function () {
  $(this).toggleClass('active');
});

new function(){
	var footerId = "footer";
	//メイン
	function footerFixed(){
		//ドキュメントの高さ
		var dh = document.getElementsByTagName("body")[0].clientHeight;
		//フッターのtopからの位置
		document.getElementById(footerId).style.top = "0px";
		var ft = document.getElementById(footerId).offsetTop;
		//フッターの高さ
		var fh = document.getElementById(footerId).offsetHeight;
		//ウィンドウの高さ
		if (window.innerHeight){
			var wh = window.innerHeight;
		}else if(document.documentElement && document.documentElement.clientHeight != 0){
			var wh = document.documentElement.clientHeight;
		}
		if(ft+fh<wh){
			document.getElementById(footerId).style.position = "relative";
			document.getElementById(footerId).style.top = (wh-fh-ft-1)+"px";
		}
	}
	//文字サイズ
	function checkFontSize(func){
		//判定要素の追加
		var e = document.createElement("div");
		var s = document.createTextNode("S");
		e.appendChild(s);
		e.style.visibility="hidden"
		e.style.position="absolute"
		e.style.top="0"
		document.body.appendChild(e);
		var defHeight = e.offsetHeight;
		//判定関数
		function checkBoxSize(){
			if(defHeight != e.offsetHeight){
				func();
				defHeight= e.offsetHeight;
			}
		}
		setInterval(checkBoxSize,1000)
	}
	//イベントリスナー
	function addEvent(elm,listener,fn){
		try{
			elm.addEventListener(listener,fn,false);
		}catch(e){
			elm.attachEvent("on"+listener,fn);
		}
	}
	addEvent(window,"load",footerFixed);
	addEvent(window,"load",function(){
		checkFontSize(footerFixed);
	});
	addEvent(window,"resize",footerFixed);
}
//初回アニメーション
$(function () {
  var webStorage = function () {
    const logo = document.querySelector('.p-top-mv__logo');
    const text = document.querySelector('.p-top-mv__text');
    if (sessionStorage.getItem('access')) {
      /*
        2回目以降アクセス時の処理
      */
      $(".l-header").addClass('is-active');
      $("#menu-button").addClass('is-active');
      $(".p-top-mv-scroll").addClass('is-active');
      const animation2 = lottie.loadAnimation({
        container: text,
        loop: false,
        autoplay: true,
        path: '/wp/wp-content/themes/mt/assets/images/top/data.json'
      });
      setTimeout(function () {
        const animation = lottie.loadAnimation({
          container: logo,
          renderer: 'svg',
          loop: false,
          autoplay: true,
          path: '/wp/wp-content/themes/mt/assets/images/top/mt.json'
        });
      }, 2000);
    } else {
      /*
        初回アクセス時の処理
      */
      sessionStorage.setItem('access', 'true'); // sessionStorageにデータを保存
      setTimeout(function () {
        const animation2 = lottie.loadAnimation({
          container: text,
          renderer: 'svg',
          loop: false,
          autoplay: true,
          path: '/wp/wp-content/themes/mt/assets/images/top/data.json'
        });
      }, 500);
      setTimeout(function () {
        $(".p-top-mv__logo").addClass('visible');
        const animation = lottie.loadAnimation({
          container: logo,
          renderer: 'svg',
          loop: false,
          autoplay: true,
          path: '/wp/wp-content/themes/mt/assets/images/top/mt.json'
        });
      }, 2500);
      setTimeout(function () {
        $(".l-header").addClass('is-active');
        $("#menu-button").addClass('is-active');
      }, 5000);
      setTimeout(function () {
        $(".p-top-mv-scroll").addClass('is-active');
      }, 5500);
    }
  }
  webStorage();
});

//トップページ、WORKS横スクロールHINT
new ScrollHint('.js-scrollable');
